import { Controller } from "@hotwired/stimulus";
import * as React from "react";
import * as ReactDOM from "react-dom";

import CompetitorsListAutosuggest from "../competitors_list_autosuggest";

// Controller to render the competitors search input
export default class CompetitorsModalController extends Controller {
  static targets = ["content"];

  declare contentTarget: HTMLElement;

  connect(): void {  
    ReactDOM.render(
      React.createElement(CompetitorsListAutosuggest),
      this.contentTarget,
    );
  }
}
